import React from "react";
import { DebounceInput } from "react-debounce-input";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";

const debounceStyle = (props) => {
     return (
          <>
               <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">
                         Search
                    </InputLabel>
                    <OutlinedInput
                         {...props}
                         type="search"
                         className="blackClear"
                         endAdornment={
                              <InputAdornment position="end">
                                   <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                   >
                                        <SearchIcon />
                                   </IconButton>
                              </InputAdornment>
                         }
                         label="Search"
                         onChange={props.onChange}
                    />
               </FormControl>
          </>
     );
};

export default function UiSearch(props) {
     const searchOnChange = (e) => {
          props.onChange(e.target.value);
     };

     return (
          <DebounceInput
               element={debounceStyle}
               className="ui-x f-left"
               id="user-first-name-field"
               placeholder="Search..."
               name={"search"}
               autoFocus
               onChange={searchOnChange}
               minLength={0}
               debounceTimeout={500}
               value={""}
               autoComplete="off"
          />
     );
}
